export default "__VITE_ASSET__726130af__"